<template>
  <div
    class="operation-report-show-footer-edit w-full flex justify-center items-center"
  >
    <cancel-button v-bind="cancelButtonProps" @click="onCancel" />
    <update-button v-bind="updateButtonProps" @click="onUpdate" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("operationReport");
import UpdateButton from "@/views/enterprise/addon/operation/components/buttons/InvokeButton";
import CancelButton from "@/views/enterprise/addon/operation/components/buttons/RevokeButton";
import {
  pushShowScreen,
  notifyUpdateSuccess,
  notifyUpdateFailed,
  validateEditForms,
} from "@/utils/operations";
import { ColorMixin } from "@/mixins";
const { AISEA_COLOR } = ColorMixin.data();

export default {
  name: "OperationReportShowFooterEdit",
  components: {
    UpdateButton,
    CancelButton,
  },

  computed: {
    cancelButtonProps() {
      return {
        text: this.$t("Views.Operation.Edit.Cancel.Button.text"),
      };
    },
    updateButtonProps() {
      return {
        text: this.$t("Views.Operation.Edit.Update.Button.text"),
      };
    },
  },

  methods: {
    ...mapActions({
      updateCurrentOperationReport: "updateCurrentOperationReport",
    }),
    onCancel() {
      pushShowScreen(this, this.$route.params);
    },
    async onUpdate() {
      try {
        const isValid = await validateEditForms(this, document);
        if (!isValid) {
          notifyUpdateFailed(this, { text: "入力内容に不備があります" }); // validateに失敗
          return;
        }
        this.$vs.loading({ color: AISEA_COLOR.BLUE });
        const result = await this.updateCurrentOperationReport();
        if (!result.status) {
          throw new Error(result.message);
        }
        notifyUpdateSuccess(this); // データ更新成功
        setTimeout(() => {
          pushShowScreen(this, this.$route.params); // 詳細に遷移
        }, 500);
      } catch (e) {
        notifyUpdateFailed(this); // データ更新でエラー
      } finally {
        this.$nextTick(() => {
          this.$vs.loading.close();
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/vuexy/_variables.scss";
.operation-report-show-footer-edit {
  column-gap: 25px;
}
</style>
